// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
// @ts-ignore
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function MonthlyTaxRow() {
   const state = useQuoteContext()
   const permissions = state.featurePermissions['MonthlyTax']
   const permissionsShowMRROnDifferenceQuotes =
      state.featurePermissions['ShowMRROnDifferenceQuotes']
   const ShowMRROnDifferenceQuotes =
      permissionsShowMRROnDifferenceQuotes.includes(state.user_role)

   if (state.product_list['monthlyTax']?.NotInPricebook) {
      return <> </>
   }

   if (permissions.includes(state.user_role) || state.monthlyTax > 0)
      return (
         <div className='row'>
            <div className='col-bhr1'>
               {state.product_list['monthlyTax']['ProductName']}
            </div>
            <div className='col-bhr2'>
               <input
                  className='form-control'
                  type='number'
                  value={
                     state.monthlyTax <= 0 ? '' : state.monthlyTax.toString()
                  }
                  onChange={(e) => state.setMonthlyTax(Number(e.target.value))}
                  onBlur={() =>
                     state.setMonthlyTax(
                        Math.floor(state.monthlyTax * 100) / 100,
                     )
                  }
                  min={0}
                  placeholder={'0'}
               />
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.MonthlyTaxCosts.totalPrice,
                  state.currencyObject,
               )}
            </div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col col-bhr-blue'>
                     {state.MonthlyTaxCosts.previousTotalPrice > 0 &&
                        formatFloatAsCurrencySymbol(
                           state.MonthlyTaxCosts.previousTotalPrice,
                           state.currencyObject,
                        )}
                  </div>
                  <span className='col'>
                     {formatFloatAsCurrencySymbol(
                        state.MonthlyTaxCosts.totalPriceDifference || 0,
                        state.currencyObject,
                     )}
                  </span>
                  {process.env.REACT_APP_ENVIRONMENT == 'staging' && (
                     <div className='col'>
                        {formatFloatAsCurrencySymbol(
                           state.MonthlyTaxCosts.MRRTotal || 0,
                           state.currencyObject,
                        )}
                     </div>
                  )}
               </>
            ) : (
               <></>
            )}
         </div>
      )

   return null
}
